import { render, staticRenderFns } from "./SalesCurrentAccounts.vue?vue&type=template&id=1e524bcc&scoped=true"
import script from "./SalesCurrentAccounts.vue?vue&type=script&lang=js"
export * from "./SalesCurrentAccounts.vue?vue&type=script&lang=js"
import style0 from "./SalesCurrentAccounts.vue?vue&type=style&index=0&id=1e524bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e524bcc",
  null
  
)

export default component.exports